// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2SIEU","ranges":"BmiRanges_ranges__3KyIL"};